import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import CIcon from "@coreui/icons-react";
import {
  cilSpeedometer,
  cilGroup,
  cilHistory,
  cilUserPlus,
  cilUser,
  cilFile,
  cilChart,
  cilImage,
} from "@coreui/icons";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { CBadge, CSidebarNav } from "@coreui/react-pro";
import { Link } from "react-router-dom";
export const SidebarItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openItem, setOpenItem] = useState(null);
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  let permissions;
  try {
    permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  } catch (e) {
    console.error("Failed to parse permissions from localStorage:", e);
    permissions = [];
  }

  const hasPermission = (permissionGroup, permissionName) => {
    return permissions.some(
      (perm) =>
        perm.permission_group === permissionGroup &&
        perm.permission_name === permissionName
    );
  };

  const items = [
    {
      name: "Dashboard",
      to: "/dashboard",
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    },
    hasPermission("Dashboard Management", "List") && {
      name: "Early Renewal Reminders",
      to: "/early-renewal-reminders",
      icon: <i className="bi bi-bell nav-icon"></i>,
    },
    (hasPermission("Admin Management", "List") ||
      hasPermission("User Management", "List") ||
      hasPermission("Role Management", "List")) && {
      name: "User Management",
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
      toggle: true,
      items: [
        hasPermission("Admin Management", "List") && {
          name: "Admin Users",
          to: "/admins",
          icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        },
        hasPermission("User Management", "List") && {
          name: "Registered Users",
          to: "/users",
          icon: <i className="bi bi-person-badge nav-icon"></i>,
        },
        hasPermission("Role Management", "List") && {
          name: "Roles",
          to: "/roles",
          icon: <i className="bi bi-person-lines-fill nav-icon"></i>,
        },
      ].filter(Boolean),
    },
    hasPermission("Policy Management", "List") && {
      name: "Insurance Policies",
      to: "/insurance-policies",
      icon: <i className="bi bi-shield-check nav-icon"></i>, // Updated icon for Insurance Plan
      // disabled: true,
    },
    hasPermission("Order Management", "List") && {
      name: "Order Management",
      to: "/orders",
      icon: <i className="bi bi-file-earmark-text nav-icon"></i>,
      //toggle: true,
      // disabled: true,
      // items: [
      //   {
      //     name: "Product",
      //     to: "/orders/product",
      //     icon: <i className="bi bi-box-seam nav-icon"></i>,
      //     // disabled: true,
      //   },
      //   {
      //     name: "API",
      //     to: "/orders/api",
      //     icon: <i className="bi bi-code-slash nav-icon"></i>,
      //     // disabled: true,
      //   },
      //   {
      //     name: "Inquiry",
      //     to: "/orders/inquiry",
      //     icon: <i className="bi bi-question-circle nav-icon"></i>,
      //     // disabled: true,
      //   },
      // ],
    },
    hasPermission("Quote Management", "List") && {
      name: "Requests",
      to: "/requests",
      icon: <i className="bi bi-journal-text nav-icon"></i>,
      // disabled: true,
    },
    hasPermission("Product Service Management", "List") && {
      name: "Product Management",
      icon: <i className="bi bi-journal-text nav-icon"></i>,
      toggle: true,
      // disabled: true,
      items: [
        {
          name: "Motor Insurance",
          to: "/motor-insurance",
          icon: <i className="bi bi-box-seam nav-icon"></i>,
          // disabled: true,
        },
      ],
    },
    hasPermission("Short Management", "List") && {
      name: "Shorts",
      to: "/shorts",
      icon: <i className="bi bi-camera-video nav-icon"></i>,
      // disabled: true,
    },
    hasPermission("Carousel Banner Management", "List") && {
      name: "Banners",
      to: "/banners",
      icon: <CIcon icon={cilImage} customClassName="nav-icon" />,
    },
    hasPermission("Audit Trail Management", "List") && {
      name: "Audit Logs",
      to: "/audit-logs",
      icon: <CIcon icon={cilHistory} customClassName="nav-icon" />,
    },
    {
      name: "App Settings",
      to: "/settings",
      icon: <i className="bi bi-gear nav-icon"></i>,
    },
    hasPermission("Order Management", "List") && {
      name: "Paid but Uninsured",
      to: "/reports/paid-uninsured",
      icon: <i className="bi bi-exclamation-triangle nav-icon"></i>,
    },
    hasPermission("Finance Report Management", "List") && {
      name: "Finance Reports",
      to: "/reports/policy-reconciliation",
      icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
    },
    // {
    //   name: "Invoice / Receipt",
    //   to: "/invoice-receipt",
    //   icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
    //   disabled: true,
    // },
    // {
    //   name: "Reporting",
    //   to: "/reporting",
    //   icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
    //   disabled: true,
    // },
  ].filter(Boolean);

  useEffect(() => {
    if (!initialCheckDone) {
      const activeItemIndex = items.findIndex(
        (item) =>
          item.toggle &&
          item.items.some((subItem) => location.pathname.startsWith(subItem.to))
      );

      if (activeItemIndex !== -1) {
        setOpenItem(activeItemIndex);
      } else {
        const parentItemIndex = items.findIndex((item) =>
          location.pathname.startsWith(item.to)
        );
        setOpenItem(parentItemIndex !== -1 ? parentItemIndex : null);
      }

      setInitialCheckDone(true);
    }
  }, [location.pathname, items, initialCheckDone]);

  const navLink = (name, icon) => {
    return (
      <>
        {icon && <span className="nav-icon">{icon}</span>}
        {name && <span>{name}</span>}
      </>
    );
  };

  const navItem = (item, index) => {
    const { name, icon, to, disabled, toggle, items } = item;

    if (toggle) {
      return (
        <div key={index}>
          <div
            onClick={() => setOpenItem(openItem === index ? null : index)}
            className={`sidebar-item ${disabled ? "disabled" : ""}`}
            style={{
              cursor: disabled ? "not-allowed" : "pointer",
              pointerEvents: disabled ? "none" : "auto",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {navLink(name, icon)}
            <i
              className={`bi bi-chevron-down arrow ${
                openItem === index ? "rotate" : ""
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {openItem === index &&
            items.map((subItem, subIndex) => (
              <Link
                key={subIndex}
                to={subItem.to}
                onClick={(e) => {
                  if (subItem.disabled) {
                    e.preventDefault();
                  }
                }}
                className={`sidebar-item no-underline collapsible-item ${
                  location.pathname.startsWith(subItem.to) ? "active" : ""
                } ${subItem.disabled ? "disabled" : ""}`}
                style={{
                  cursor: subItem.disabled ? "not-allowed" : "pointer",
                  pointerEvents: subItem.disabled ? "none" : "auto",
                }}
              >
                {navLink(subItem.name, subItem.icon)}
              </Link>
            ))}
        </div>
      );
    }

    return (
      <Link
        key={index}
        to={to}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
          } else {
            setOpenItem(null);
          }
        }}
        className={`sidebar-item no-underline ${
          location.pathname.startsWith(to) ? "active" : ""
        } ${disabled ? "disabled" : ""}`}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        {navLink(name, icon)}
      </Link>
    );
  };

  return (
    <CSidebarNav as={SimpleBar}>
      {items.map((item, index) => navItem(item, index))}
    </CSidebarNav>
  );
};
